import { useMutation } from '@apollo/client'
import { SIGN_OUT_MUTATION } from '../gql/mutations'
import { t } from '../utils/i18n'
import { useAuth } from '../utils/auth'
import { useRouter } from 'next/router'
import useErrorHandling from '../utils/hooks/useErrorHandling'
import { refreshCurrentUserQueries } from '../utils/auth/CurrentUserProvider'
import { useTheme } from 'next-themes'
import SignOutIcon from '@public/images/sign-out-icon.svg?component'

const SignOutLink: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { setCurrentUser } = useAuth()
  const { setTheme } = useTheme()
  const router = useRouter()
  const errorHandling = useErrorHandling()

  const [doLogout] = useMutation(SIGN_OUT_MUTATION, {
    onError: errorHandling,
    onCompleted: async () => {
      await router.push('/')
      setCurrentUser(null)
      setTheme('dark')
    },
    refetchQueries: refreshCurrentUserQueries()
  })

  return (
    <a
      onClick={() => {
        doLogout()
        onClick && onClick()
      }}
    >
      <SignOutIcon />
      <span>{t('Sign Out')}</span>
    </a>
  )
}

export default SignOutLink
